/* assets/pf-draft.js —— 设计台「草稿」模块（2026-10-12 甲1：自 sections/design-canvas.liquid 外置）
   ────────────────────────────────────────────────────────────────────────────────────────
   为什么外置：section 已贴 Shopify 单 asset 256KB 硬顶（余量 140 B），任何净增都 422。
   本节延续 2026-09-20「绘画板引擎外置 assets/hd-draw.js」的既定策略。

   唯一接口（与 __hdDraw 同模式）：
     · 依赖注入 —— section 在 DOMContentLoaded 内设 `window.__pfmDraftDeps`（initCanvas 之后）
     · 启动     —— section 调 `window.__pfmDraft.init()`
     · 回桥     —— `window.__pfmDraft.save()`（云端工程恢复成功后要落一次）
                   `window.__pfmDraftBarSync()`（工程取不到时把草稿条放回来）

   🔴 单一实现：多面恢复**复用既有「切面」逻辑**（chip onclick → 从 placementArt 恢复 + 重画 grid），
      本模块不另写 restoreState 循环、不复制切面判定。

   草稿格式 v2（多面）：
     localStorage['hd_draft_<pid>']      = { v:2, plc:<当前面>, ts:<ms>, faces:{ <面>: <canvasJSON> } }
   兼容 v1（单面）：裸 canvasJSON，面名取自 'hd_draft_meta_<pid>' 的 { plc, ts }。
*/
(function(){
  'use strict';

  var D = null;                 // 依赖袋
  var c = null;                 // fabric canvas
  var saveT = null;
  var DK = 'hd_draft_x', MK = 'hd_draft_meta_x';
  var hasDesignUrl = false;

  function deps(){ return D || {}; }
  function call(name){ var f = deps()[name]; return (typeof f === 'function') ? f() : undefined; }
  function q(id){ var f = deps().q; return f ? f(id) : null; }
  function art(){ return deps().placementArt || {}; }
  function curPlc(){ var v = call('currentPlacement'); return v == null ? '' : v; }
  function chip(k){ return document.querySelector('#pfmPlacements .pfm-chip[data-p="' + k + '"]'); }

  /* 「真实作品件数」—— grid 每面重画、isPreview 是瞬态层，都不算内容 */
  function countOf(src){
    try{
      var arr = (typeof src === 'string') ? JSON.parse(src).objects : (src && src.objects);
      return ((arr || []).filter(function(o){ return !o.isGrid && !o.isPreview; })).length;
    }catch(e){ return 0; }
  }
  function liveCount(){
    if(!c || !c.getObjects) return 0;
    return c.getObjects().filter(function(o){ return !o.isGrid && !o.isPreview; }).length;
  }

  /* 读草稿 → 归一成 { 面名: canvasJSON }（兼容 v1 单面） */
  function readFaces(){
    var raw = null;
    try{ raw = localStorage.getItem(DK); }catch(e){}
    if(!raw) return {};
    var d = null; try{ d = JSON.parse(raw); }catch(e){}
    if(!d) return {};
    if(d.v === 2 && d.faces && typeof d.faces === 'object') return d.faces;
    var meta = null; try{ meta = JSON.parse(localStorage.getItem(MK) || 'null'); }catch(e){}
    var out = {}; out[(meta && meta.plc) || 'front_large'] = d;
    return out;
  }
  function draftTs(){
    try{ var d = JSON.parse(localStorage.getItem(DK) || 'null'); return (d && d.ts) || 0; }catch(e){ return 0; }
  }
  function ago(ts){
    if(!ts) return '';
    var m = Math.floor((Date.now() - ts) / 60000);
    if(m < 1) return 'just now';
    if(m < 60) return m + ' min ago';
    var h = Math.floor(m / 60);
    return h < 24 ? h + ' h ago' : Math.floor(h / 24) + ' d ago';
  }
  function faceLabel(k){
    /* 面名文案的唯一实现在 rerenderPlacements 里（写进 chip）—— 此处只读，不写第二套 */
    var ch = chip(k);
    return ch ? ch.textContent.trim() : k;
  }

  /* ── 保存：把「所有有内容的面」一起写进草稿 ── */
  function save(){
    clearTimeout(saveT);
    saveT = setTimeout(function(){
      try{
        /* 写入守卫只能是「真实作品数」—— drawGrid() 每次初始化都会 add() 三个 grid 对象，
           若按 getObjects().length 判断，页面一加载就会用「只有 grid 的空草稿」覆盖上一次的真草稿。 */
        if(liveCount() > 0){
          var j = c.toJSON();
          /* 2026-10-14: 当前面**也不再保存 grid/preview** —— 与其余面一致。🔴 顺序约束：设计台必须先上线
             「restoreState 内重建打印区框」，本改动才可上线；否则草稿丢框后恢复将没有任何打印区框。
             理由：草稿里的框经 restoreState(loadFromJSON) 回来时**可选中/可拖动/可旋转**（fabric 不序列化
             selectable），用户误碰一次就把框转歪，并被存回草稿永久传染。框一律由 drawGrid() 按当前
             打印区重建。 */
          if(j && Array.isArray(j.objects)) j.objects = j.objects.filter(function(o){ return !o.isGrid && !o.isPreview; });
          var A = art(), F = {}, cur = curPlc();
          Object.keys(A).forEach(function(k){
            if(k === cur) return;
            if(A[k] && A[k].json) F[k] = JSON.parse(A[k].json);
          });
          F[cur] = j;
          localStorage.setItem(DK, JSON.stringify({ v:2, plc: cur, ts: Date.now(), faces: F }));
          localStorage.removeItem(MK);
        }
      }catch(e){}
      barAuto();
    }, 800);
  }

  /* ── 草稿条：只在「画布为空 + 有草稿」时出现 ── */
  function barSync(){
    var bar = q('pfmDraftBar'); if(!bar) return;
    /* 2026-10-14：本次会话点过 ✕ ⇒ 不再自动弹出（草稿仍在，只是不打扰） */
    try{ if(sessionStorage.getItem('hd_draft_dismiss') === '1'){ bar.classList.remove('show'); return; } }catch(e){ }
    var F = readFaces(), ks = Object.keys(F), n = 0;
    ks.forEach(function(k){ n += countOf(F[k]); });
    /* design_id / design_url 预载时压制 —— 用户是回来改「云端工程」的，本地那份无关草稿不该抢戏 */
    if(!n || hasDesignUrl || call('preloadDocId') || liveCount() > 0){ bar.classList.remove('show'); return; }
    var mt = q('pfmDraftMeta');
    if(mt){
      var labels = ks.filter(function(k){ return countOf(F[k]) > 0; }).map(faceLabel);
      var face = labels.length > 2 ? labels.slice(0,2).join(' + ') + ' +' + (labels.length - 2) : labels.join(' + ');
      mt.textContent = n + (n === 1 ? ' item' : ' items')
        + (face ? ' · ' + face : '')
        + (draftTs() ? ' · ' + ago(draftTs()) : '');
    }
    bar.classList.add('show');
  }
  /* 轻量版：只在「有作品」时收起。完整判定 barSync() 只跑 init / restore / discard ——
     否则用户主动清空画布会立刻弹出 Restore，像在质问用户。 */
  function barAuto(){
    var bar = q('pfmDraftBar'); if(!bar) return;
    if(liveCount() > 0) bar.classList.remove('show');
  }

  /* ── 恢复：逐面回填，复用既有「切面」逻辑（单一实现） ── */
  function restore(){
    var bar = q('pfmDraftBar');
    /* 2026-10-14：进「恢复中」态 —— 草稿条**原地**变成加载条（文案 + 进度条），
       直到 finish()（所有面都恢复完）才随草稿条一起收起。
       ⚠️ 恢复是**逐面**做的（复用切面逻辑），多面时耗时明显，所以要给用户可见反馈。 */
    var _t0 = Date.now();
    /* 加载条**最短显示时长**：实测恢复常在 300ms 内跑完（纯文字草稿），
       不给下限的话进度条会"闪一下"（用户根本看不到）。多面/带图草稿本来就更久，不受影响。 */
    var MIN_SHOW = 650;
    /* 2026-10-16：防重入 —— 连点 Pick up 不再跑两遍逐面恢复。 */
    if(restore._busy) return; restore._busy = true;
    setTimeout(function(){ restore._busy = false; }, 6000);
    try{ if(bar) bar.classList.add('is-restoring'); }catch(e){}
    /* 2026-10-17：统一收口（用户实测「恢复草稿一直卡住」）——
       任何提前 return / 异常都必须摘掉 is-restoring，否则草稿条永远停在「Restoring…」。
       根因：旧格式/字符串格式草稿 ⇒ 下面的 ks 过滤为空 ⇒ 早退却不收口。 */
    var _settled = false, _wd = null;
    function settle(delay){
      if(_settled) return; _settled = true;
      if(_wd){ clearTimeout(_wd); _wd = null; }
      setTimeout(function(){ try{ if(bar) bar.classList.remove('show','is-restoring'); }catch(e){} }, Math.max(0, delay || 0));
    }
    _wd = setTimeout(function(){ if(!_settled) settle(0); }, 8000);   /* 8s 兜底：没走到 finish 也强制收 */
    var F = readFaces();
    /* 与 barSync 同口径（barSync 用 countOf 数件数）—— countOf 本身兼容字符串，
       别再额外要求 F[k].objects（那正是「显示 1 item 却恢复直接早退」的来源）。 */
    var ks = Object.keys(F).filter(function(k){ return countOf(F[k]) > 0; });
    if(!ks.length){ settle(0); return; }
    try{ call('flushPendingSave'); }catch(e){}   // 维持「栈顶=当前画布」不变量 → 恢复可被 Ctrl+Z 撤回
    /* 1) 各面先灌进 placementArt —— 这是切面逻辑的数据源；json 不含 grid，grid 由切面 resize 重画 */
    var A = art(), cur = curPlc();
    ks.forEach(function(k){ A[k] = { json: JSON.stringify(F[k]), hasArt: true }; });
    /* 2) 程序化切面：逐个复用 chip 的既有 onclick（禁第二份恢复实现），最后回到起始面 */
    var runSeq = function(){
      var start = ks.indexOf(cur) >= 0 ? cur : ks[0];
      var seq = ks.concat([start]), i = 0;
      (function step(){
        if(i >= seq.length){ finish(); return; }
        var k = seq[i++];
        var ch = chip(k);
        if(!ch){ step(); return; }                 // 面不存在（旧草稿的孤儿面名）→ 跳过
        if(k === curPlc()){ setTimeout(step, 120); return; }
        try{ ch.click(); }catch(e){}
        waitArt(function(){ setTimeout(step, 60); });   // 等该面 art 落画布（enlivenObjects 是异步的）
      })();
    };
    /* 3) 🔴🔴 必须**先把「当前面」恢复进画布**，再启动切面序列 —— 否则必丢当前面。
       切面 handler 在**离开**当前面时会无条件把「当前画布快照」写回 placementArt[当前面]；
       而刷新后画布是空的 ⇒ 第一次切面就把上面刚灌入的当前面草稿**覆盖成空**
       （实测：草稿 faces 两面都在、back 正常恢复、front 变空 = [Object×3] 只有 grid）。
       用 restoreState（= 云端工程恢复的**同一条**路径），等 art 落画布后再切。 */
    if(ks.indexOf(cur) >= 0){
      try{ var _rs = deps().restoreState; if(_rs) _rs(F[cur]); }catch(e){}
      waitArt(runSeq);
    } else {
      runSeq();   // 当前面本就没内容（画布空 == 正确）⇒ 直接切
    }
    function waitArt(cb){
      var n = 0;
      (function w(){
        n++;
        if(liveCount() > 0 || n > 40){ cb(); return; }   // 上限 4s：图片加载失败也不至于卡死
        setTimeout(w, 100);
      })();
    }
    function finish(){
      try{ c.renderAll(); }catch(e){}
      /* 2026-10-16 修复：**把设计层重画到产品图**。原先只 renderAll(画布)，
         产品图上的设计层不刷新 ⇒ 必须手动切角度（setFace 里才有 stageArt）才看得见。
         补一次 + 140ms 再补一次，对齐 setFace 的双兜底。 */
      try{ window.__pfmStageArt && window.__pfmStageArt(); }catch(e){}
      setTimeout(function(){ try{ window.__pfmStageArt && window.__pfmStageArt(); }catch(e){} }, 140);
      try{ call('saveState'); }catch(e){}
      try{ call('updateLayers'); }catch(e){}
      try{ call('updatePlacementDots'); }catch(e){}
      try{ if(window.__pfmUpdateFloat) window.__pfmUpdateFloat(); }catch(e){}
      /* 收起草稿条 + 退出「恢复中」态（不早于 MIN_SHOW，避免加载条一闪而过） */
      settle(Math.max(0, MIN_SHOW - (Date.now() - _t0)));   /* 统一走收口（顺带清 8s 看门狗） */
    }
  }

  function discard(){
    try{ localStorage.removeItem(DK); localStorage.removeItem(MK); }catch(e){}
    var bar = q('pfmDraftBar'); if(bar) bar.classList.remove('show');
  }

  function init(){
    D = window.__pfmDraftDeps || {};
    c = call('canvas') || window.__pfmCanvas;
    var pid = call('pid') || 'x';
    DK = 'hd_draft_' + pid;
    MK = 'hd_draft_meta_' + pid;
    hasDesignUrl = !!deps().hasDesignUrl;
    if(c && c.on){
      c.on('object:added', save);
      c.on('object:modified', save);
      c.on('object:removed', save);
    }
    var rb = q('pfmDraftRestore'); if(rb) rb.addEventListener('click', restore);
    var dbx = q('pfmDraftDiscard'); if(dbx) dbx.addEventListener('click', discard);
    /* 2026-10-14：✕ —— 只收起本次提示（记进 sessionStorage），**不删草稿** */
    var dx = q('pfmDraftClose'); if(dx) dx.addEventListener('click', dismiss);
    barSync();
    setTimeout(barSync, 3000);   // placements chips 异步就绪后刷一次面名
  }

  /* ✕：本次会话不再提示（草稿保留） */
  function dismiss(){
    try{ sessionStorage.setItem('hd_draft_dismiss', '1'); }catch(e){ }
    var bar = q('pfmDraftBar'); if(bar) bar.classList.remove('show');
  }

  window.__pfmDraft = { init: init, save: save, restore: restore, barSync: barSync, discard: discard };
  window.__pfmDraftBarSync = barSync;
})();
